import { render, staticRenderFns } from "./cpt-chart-td-column-option.vue?vue&type=template&id=f1a2b4ac&scoped=true"
import script from "./cpt-chart-td-column-option.vue?vue&type=script&lang=js"
export * from "./cpt-chart-td-column-option.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1a2b4ac",
  null
  
)

export default component.exports